import { getStatusDotColor } from "../../utils/battery";

export function StatusDot({ text }) {
  const color = getStatusDotColor(text);
  return (
    <span className="sb-dot" style={{ background: color }} aria-hidden="true" />
  );
}
